import { Center as NbCenter } from 'native-base';

import { addWithConfig } from '../../utils';

export const Center = NbCenter;

export default addWithConfig(Center);
